export const loading = () => ({ status: "loading" });
export const failed = (error) => ({ status: "error", error });
export const denied = (capability) => ({
    status: "forbidden",
    capability,
});
export const empty = () => ({ status: "empty" });
export const ready = (data) => ({ status: "ready", data });
//# sourceMappingURL=index.js.map